<main *ngIf="form">
    <tarifrechner-common-loading-screen [loading]="isLoading | async" text="Preis wird berechnet..."></tarifrechner-common-loading-screen>
    <div class="baugeraete-zusammenfassung h-spacer-l l-container l-container--m">
    <form [formGroup]="form">

        <!-- Preisübersicht -->
        <div class="l-container l-container--m h-text-center">
            <h1 class="h-spacer-l">{{currentSeite.seiteDefinition.label}}</h1>

            <div class="h-font-regular h-color-black">
                <p class="h-font-m h-font-medium" style="margin:0">Unverbindlicher Nettobeitrag</p>
                <h1 class="h-font-xxl h-color-pri-dark">
                    {{ (beitragsdaten | async)?.gesamtJahresNettoBeitrag | currency:'EUR':'symbol-narrow' }}
                    <span class="h-font-m h-font-medium h-color-black">jährlich</span>
                </h1>
            </div>

            <div class="h-font-regular h-color-black">
                <span class="h-font-m">
                    Brutto
                    <strong>{{ (beitragsdaten | async)?.gesamtJahresBruttoBeitrag | currency:'EUR':'symbol-narrow' }}</strong>
                    jährlich
                </span>
                <p style="margin-top: 0 !important; line-height: 1; margin-bottom: 1rem !important;">
                    <span class="h-font-s">(inkl. 19% Versicherungsteuer)</span>
                </p>
            </div>
        </div>

        <!-- Ihre Vorteile auf einen Blick -->
        <div class="baugeraete-zusammenfassung__box l-container l-container--m" style="padding-top: 0.5rem;">
            <h2 class="h-font-l h-font-medium h-color-black">Ihre Vorteile auf einen Blick</h2>

            <p class="h-text-left h-font-m h-font-medium h-color-black">
                    <span>
                        <svg class="icon h-color-pri">
                            <use xlink:href="#icon-check"></use>
                        </svg>
                    </span>
                Mehrkosten für Ersatzgerät
            </p>
            <p class="h-text-left h-font-m h-font-medium h-color-black">
                    <span>
                        <svg class="icon h-color-pri">
                            <use xlink:href="#icon-check"></use>
                        </svg>
                    </span>
                Abhandenkommen durch Diebstahl
            </p>
            <p class="h-text-left h-font-m h-font-medium h-color-black">
                    <span>
                        <svg class="icon h-color-pri">
                            <use xlink:href="#icon-check"></use>
                        </svg>
                    </span>
                GAP-Deckung
            </p>
        </div>

        <!-- Zusätzliche Absicherung -->
        <div *ngIf="zusaetzlicheAbsicherung">
            <h2 class="h-spacer-s h-text-left h-font-l">Ihre zusätzliche gewählte Absicherung</h2>

            <div class="h-spacer-l">
                <p class="h-text-left h-font-m h-font-regular h-color-black" *ngIf="feuerrisiko">Feuerversicherung bei landwirtschaftlichen Gebäuden</p>
                <p class="h-text-left h-font-m h-font-regular h-color-black" *ngIf="minderertragsdeckung">Minderertragsversicherung</p>
            </div>
        </div>

        <div class="l-container l-container--s">
            <button class="m-button m-button--full h-spacer-s weiter-button" type="button" (click)="onSubmit()">
                <span>Weiter</span>
            </button>
        </div>

        <div class="l-container l-container--m" *ngIf="versicherungsBeginnElement && zahlweiseElement">
            <h2 class="h-spacer-m">Das Wichtigste in der Übersicht:</h2>

            <ul class="m-list m-list--icon m-list--icon-horizontal">
                <li>
                    <svg class="icon">
                        <use xlink:href="#icon-calendar"></use>
                    </svg>
                    <span>
                        <strong>{{versicherungsBeginnElement.attribut.label}}</strong><br>
                        <datepicker-element (change)="this.setVersicherungsAblaufOptionsUndBerechne()" class="datepicker" [element]="versicherungsBeginnElement" [form]="form" min-date="{{this.minVersicherungsbeginn}}" max-date="{{getMaxVersicherungsbeginn()}}" click-opens="true" allow-input="false" value="{{getVersicherungsbeginn()}}"></datepicker-element>
                    </span>
                </li>
                <li>
                    <svg class="icon">
                        <use xlink:href="#icon-clock"></use>
                    </svg>
                    <span>
                        <strong>{{versicherungsAblaufElement.attribut.label}}</strong><br>
                        <form-select class="ergebnisUebersichtElement" (change)="this.versicherungsablaufChange()" [element]="laufzeitElement"></form-select>
                    </span>
                </li>
                <li>
                    <svg class="icon">
                        <use xlink:href="#icon-euro"></use>
                    </svg>
                    <span>
                        <strong>Zahlungsweise:</strong><br>jährlich
                    </span>
                </li>
            </ul>
        </div>
    </form>

    <div *ngIf="isVisible(laufzeitHinweisText)">
        <div>
            <bot [noStickyBottom]="true">{{laufzeitHinweisText.attribut.label}}</bot>
        </div>
    </div>

    </div>

    <vhv-footer [show-next]="false" [page-reused]="isPageReused"></vhv-footer>
</main>
